//判断登陆状态  执行微信登陆
import jQuery from "jquery";
const STORAGE_KEY={
    LOGIN_USER:"LOGIN_DATA:CMDHRA_PC"
}
function setLoginDTO(loginDTO){
    var oldDto=getLoginDTO();
    if(!oldDto)  // 没有数据。 
    {
        oldDto={
            ssoKey:null,  //  单点登录的key。后后台匹配上就是登录状态，没有匹配就是非登录状态 
            student:null  // 用户数据。 
        }
    }
    // 深度拷贝
    var newDto =jQuery.extend({},oldDto,loginDTO)
    console.log(`storageService >>>> STORAGE_KEY=${STORAGE_KEY.LOGIN_USER} ; newDto =${newDto}`)
    // 存储上数据。 
    localStorage.setItem(STORAGE_KEY.LOGIN_USER, JSON.stringify(newDto));
};

function getLoginDTO(){
    var jsonStr=localStorage.getItem(STORAGE_KEY.LOGIN_USER);
    if(jsonStr)
    {
        return  JSON.parse(jsonStr);
    }
    else
    {
        return null;
    }
}

function logout(){
    localStorage.removeItem(STORAGE_KEY.LOGIN_USER);
}

export default {
    setLoginDTO,
    getLoginDTO,
    logout
};



// WEBPACK FOOTER //
// ./src/plugin/extendFn/storageService.js